<template><div class="d-flex justify-center">

<div style="width: 100%; max-width: 600px" class="pa-3">
	<div v-for="(cmn,index) in [cmn1, cmn2]">
		<div :class="$css.title"> {{ $t(ttl[index] ) }} </div>
		
		<p v-if="index == 1"> The best way to support the language is to help spread it! So post about it on your social networks, discuss it, invite your friends - let the world know about Nao! And you can also donate to the project:</p>

		<div v-if="$vuetify.breakpoint.xs">
		<div v-for="c in cmn">
			<div class="pa-3 text-center">
				<a :href="c.url">
					<v-icon :color="c.color" size="60px" >  {{ $mdi[c.icon] }} </v-icon>
				</a>
				<div style="text-transform: capitalize;"> {{ c.icon }} </div>
			</div>
			<div v-html="c.text"> </div>
		</div>
		</div>

		<table v-else>
		<tr v-for="c in cmn">
			<td class="pa-3 text-center">
				<a :href="c.url">
					<v-icon :color="c.color" size="60px" > {{ $mdi[c.icon] }} </v-icon>
				</a>
				<div style="text-transform: capitalize;"> {{ c.icon }} </div>
			</td>
			<td v-html="c.text" class="pa-3"> </td>
		</tr>
		</table>
	</div>

</div>

</div></template>

<script>

import Chat from '@/components/Chat'

/*
	<form action="mailto:heiabalennao@gmail.com"
	method="POST"
	enctype="multipart/form-data"
	name="EmailForm">

	    <v-text-field
            label="Your name"
            name="Contact-Name"
        ></v-text-field>

	    <v-text-field
            label="Your email"
            name="Contact-Email"
        ></v-text-field>

		<v-textarea
		  name="Contact-Message"
		  placeholder="Your message"
		  solo
		></v-textarea>

	    <button type="submit" value="Submit"> Send </button>
	</form>  

*/

export default {
	components: {Chat},
	data: function() {
		return {
			ttl: ['Community', 'Support'],
			cmn1: [
				{icon: 'Forum', url: 'https://nao.freeflarum.com/', color: "black",
				text: `<a href="https://nao.freeflarum.com/">Forum</a> is a great place to have interesting discussions that will be read by others later. All the conversations are divided into topics and categories so you can easily find what you want. It is also the best place for posting your stories, memes and other content that you create.`},

				{icon: 'Discord', url: 'https://discord.gg/nBB6NqS', color: "#7289da",
				text: `<a href="https://discord.gg/nBB6NqS"> Discord </a> community is the most active one. It has over 50 users and many channels including language-specific channels where you discuss Nao in Russian, French, Chinese and other languages. The server has a bot that you can use to translate and play games with others.`},

				{icon: 'Telegram', url: 'https://t.me/naolangbot', color: "#23aae8",
				text: `<a href="https://t.me/naolangbot">Telegram</a> is the original community. It also has a bot and the chatrooms in English, Russian and Esperanto. And the Telegram chatrooms are connected to Discord so people from both apps can talk with each other.`},

				{icon: 'Reddit', url: 'https://www.reddit.com/r/naolanguage/', color: "#FF4500",
				text: `<a href="https://www.reddit.com/r/naolanguage/">Reddit</a> is a popular platform so make sure to check out the community there.`},
			],
			cmn2: [
				{icon: 'Patreon', url: 'https://www.patreon.com/naolanguage/', color: "#FF4500",
				text: `<a href="https://www.patreon.com/naolanguage/">Patreon</a> is a great platform where you can support the development of the language and the community by donations.`},
			]
		}
	},
	methods: {

	}
}
</script>
